import React from 'react'
import BaseComponent from './BaseContainer'
import { Redirect } from 'react-router'
import SocialNetwork from '../components/form/SocialNetwork'
import { graphql, compose, withApollo } from 'react-apollo'
import createSocialNetwork from '../apollo/graphql/social-network/create'
import updateSocialNetwork from '../apollo/graphql/social-network/update'
import deleteSocialNetwork from '../apollo/graphql/social-network/delete'
import getSocialNetwork from '../apollo/graphql/social-network/get'
import getShop from '../apollo/graphql/shop/get'

class ShopSocialNetworkContainer extends BaseComponent {

  constructor(props) {
    super(props)

    const isNew = props.match.params.snId === 'new' || props.match.params.snId === undefined

    this.state = {
      status: {
        loading: false,
        message: null,
        error: null,
        isNew: isNew,
        deletion: { confirm: false }
      },
      shop: { name: '' },
      obj: { name: '', url: '', image: '' }
    }

    this.handleClick = this.handleClick.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    if (!this.state.status.isNew) {
      this.props.client.query({
        query: getSocialNetwork,
        variables: { id: this.props.match.params.snId },
      }).then(({ data }) => {
        if (getSocialNetwork.error) {
          this.setState({
            status: {
              ...this.state.status,
              error: true,
              message: getSocialNetwork.error.message
            }
          })
        }
        let newState = {
          ...this.state,
          obj: data.getSocialNetwork
        }
        newState.status.loading = false
        this.setState(newState)
      })
    } else {
      this.setState({
        ...this.state,
        status: {
          ...this.state.status,
          loading: false
        }
      })
    }
  }

  handleClick(e, media) {
    let obj = {...this.state.obj}
    obj.image = media.file

    this.setState({
      obj: {
        ...this.state.obj,
        image: obj.image
      }
    })
  }

  handleChange(event, data, type) {
    let newState = {
      obj: {
        ...this.state.obj
      }
    }
    if (event.target.files && event.target.files.length > 0) {
      //files
      newState.obj[event.target.id] = event.target.files[0]
    }  else {
      //simple data
      newState.obj[event.target.id] = event.target.value
    }
    this.setState(newState)
  }

  handleDelete(event, data) {
    event.preventDefault()
    let newState = {
      status: {
        ...this.state.status,
        deletion: {}
      }
    }
    switch (data.confirm) {
    case true:
      newState.status.deletion.confirm = true
      break
    case null:
      newState.status.deletion.confirm = false
      break
    case false:
      newState.status.deletion.confirm = false
      this.props.deleteSocialNetwork({variables: {id: this.state.obj.id}}).then(
        this.props.history.push(`/shops/${this.props.match.params.objId}/social-networks`)
      ).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true
          }
        })
      })
      break
    default:
      break
    }
    this.setState(newState)
  }

  handleSubmit(event) {
    event.preventDefault()
    this.setState({
      status: {
        ...this.state.status,
        loading: true
      }
    })

    this.state.status.isNew ?
      this.props.createSocialNetwork({
        variables: {
          shopId: this.props.match.params.objId,
          ...this.state.obj
        }
      }).then((data) => {
        this.setState({redirect: true})
      }).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true,
            isNew: true
          }
        })
      }) :
      this.props.updateSocialNetwork({
        variables: {
          ...this.state.obj
        }
      }).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true
          }
        })
      }).then(this.setState({redirect: true}))
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={`/shops/${this.props.match.params.objId}/social-networks`}/>
    }
    if (this.state.status.loading || this.props.shop.loading) {
      return <div>Chargement</div>
    }
    return (
      <SocialNetwork
        status={this.state.status}
        data={this.props.shop.getShop}
        type='shops'
        obj={this.state.obj}
        onChange={this.handleChange}
        onDelete={this.handleDelete}
        onSubmit={this.handleSubmit}
        onClick={this.handleClick} />
    )
  }
}

const ShopSocialNetworkContainerEnhanced = compose(
  graphql(getShop, {
    name: 'shop',
    options: (props) => {
      return {
        variables: { id: props.match.params.objId },
        fetchPolicy: 'network-only'
      }
    }
  }),
  graphql(updateSocialNetwork, { name: 'updateSocialNetwork' }),
  graphql(createSocialNetwork, { name: 'createSocialNetwork' }),
  graphql(deleteSocialNetwork, { name: 'deleteSocialNetwork' })
)(ShopSocialNetworkContainer)

export default withApollo(ShopSocialNetworkContainerEnhanced)



// WEBPACK FOOTER //
// ./src/containers/ShopSocialNetworkContainer.js